/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/date_format.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns a string representation of a date, in the provided format.
 *
 * @example
 * FROM employees
 * | KEEP first_name, last_name, hire_date
 * | EVAL hired = DATE_FORMAT("yyyy-MM-dd", hire_date)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'date_format',
  signatures: [
    {
      params: [
        {
          name: 'date',
          type: 'date',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'date',
          type: 'date_nanos',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'dateFormat',
          type: 'keyword',
          optional: true,
        },
        {
          name: 'date',
          type: 'date',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'dateFormat',
          type: 'keyword',
          optional: true,
        },
        {
          name: 'date',
          type: 'date_nanos',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'dateFormat',
          type: 'text',
          optional: true,
        },
        {
          name: 'date',
          type: 'date',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'dateFormat',
          type: 'text',
          optional: true,
        },
        {
          name: 'date',
          type: 'date_nanos',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
